<div class="dialog-header">
    <h2 mat-dialog-title>{{ title }}</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    @if (contextMessage) {
        <valumize-info-panel [appearance]="'INFO'" [message]="contextMessage"></valumize-info-panel>
    }
    @if ((isArchived$ | async)?.value === false) {
        <div class="button-row">
            <button mat-stroked-button (click)="openCreateDialog()">
                <mat-icon>add</mat-icon> Valuation
            </button>
        </div>
    }
    @if (fundValuationsForFundReport$ | async; as valuations) {
        @if ((fundValuationDeleteError$ | async); as fundValuationDeleteError) {
            @if (fundValuationDeleteError.statusCode) {
                <valumize-info-panel
                    [appearance]="'ERROR'"
                    [message]="fundValuationDeleteError.errorMessage">
                </valumize-info-panel>
            }
        }
        <table mat-table [dataSource]="(displayedValuations$ | async) ?? []" matSort
               matSortActive="closingDate" [matSortDirection]="sortDirection" [matSortDisableClear]="true"
               (matSortChange)="onSortChange($event)">
            <ng-container matColumnDef="selected">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    @if (element.id === currentFundValuationId) {
                        <mat-icon>check</mat-icon>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="id" sticky>
                <th mat-header-cell *matHeaderCellDef>Fund Valuation ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container>
            <ng-container matColumnDef="valuationType">
                <th mat-header-cell *matHeaderCellDef>Valuation Type</th>
                <td mat-cell *matCellDef="let element">{{ element.valuationType.code | codeFormat: codeTableFundValuationType | async }}</td>
            </ng-container>
            <ng-container matColumnDef="closingDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="closingDate">Closing Date</th>
                <td mat-cell *matCellDef="let element">{{ element.closingDate | traceableFormat }}</td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element" class="no-wrap">{{ element.description | traceableFormat }}</td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <button [matMenuTriggerFor]="menu" aria-label="More options" mat-icon-button (click)="$event.stopPropagation()">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onRowClick(element.id)">
                            <mat-icon>check</mat-icon>
                            <span>Select</span>
                        </button>
                        @if ((isArchived$ | async)?.value === false && !returnToAsset) {
                            <button
                                mat-menu-item
                                (click)="navigateToCopyWorkflowStepper(element)">
                                <mat-icon>content_copy</mat-icon>
                                Copy Fund Valuation
                            </button>
                        }
                        @if (showDeleteButton) {
                            <button mat-menu-item (click)="openDeleteConfirmation(element.id)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete Fund Valuation</span>
                            </button>
                        }
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row
                *matRowDef="let row; columns: columns"
                (click)="onRowClick(row.id)"></tr>
        </table>
    }
</mat-dialog-content>
